// extracted by mini-css-extract-plugin
export default {"helperText":"CommentSidePanel_helperText__X6wnW font-xs-regular"};